export default __webpack_public_path__ + "static/media/Letter E.5f0ba9c8.mov";